export const STORAGE_KEYS: { [id: string]: string } = {
  AUTH_EXPIRATION: "Auth.expiration",
  ROUTE_BEFORE_LOGIN: "RedirectPath",
  COPIED_WIDGET: "CopiedWidget",
  COPIED_THEME: "CopiedTheme",
  SHOW_INTERCOM_POPOVER_KEY: "SHOULD_SHOW_INTERCOM_TOOLTIP",
  CANVAS_SCALE_FACTOR: "CanvasScaleFactor",
  VISITOR_ID: "VisitorId",
  SHOW_PROMOTION_MODAL_KEY: "SHOULD_SHOW_PROMOTION_MODAL",
  PRICING_MODAL_AUTOLOADED_EPOCH_KEY: "PRICING_MODAL_AUTOLOADED_EPOCH",
  RECENT_ICON_LIST: "RECENT_ICON_LIST",
  CODE_FORMATTING_ONBOARDING_BANNER_DISMISSED:
    "CODE_FORMATTING_ONBOARDING_BANNER_DISMISSED",
  TRACK_FOCUSED_ITEMS: "TRACK_FOCUSED_ITEMS",
  REDUX: "redux",
};
